import IacManagementEmptyCellValue from "../../components/CellEmptyValue";
import IacManagementItemValue from "../../components/CellValue";
import { IacManagementStackVendorMeta } from "../../types";

type IacManagementTableVendorCellProps = {
  vendorMeta: IacManagementStackVendorMeta | undefined;
};

const IacManagementTableVendorCell = ({ vendorMeta }: IacManagementTableVendorCellProps) => {
  return vendorMeta ? (
    <IacManagementItemValue icon={vendorMeta.icon}>{vendorMeta.text}</IacManagementItemValue>
  ) : (
    <IacManagementEmptyCellValue />
  );
};

export default IacManagementTableVendorCell;
